import styled from 'styled-components'
import { color } from '../styles'
import { SPACING } from '../styles/mixins/constants'

export const PageBody = styled.div<{ row?: boolean }>`
    padding: ${SPACING[5]};
    background-color: ${color.background.app};
    display: flex;
    flex: 1 1 auto;
    min-width: 0px;
    min-height: 0px;
    flex-flow: ${(p) => (p.row ? 'row' : 'column')} nowrap;
`
